import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Suggerimento } from 'src/app/models/suggerimento';
import { BaseEditForm } from 'src/app/shared/baseEditForm';

@Component({
  selector: 'edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditSuggerimentoComponent extends BaseEditForm implements OnInit {

  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<EditSuggerimentoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Suggerimento,) {
    super();
  }

  ngOnInit() {

    this.form = this.fb.group({
      titolo: [this.data?.titolo, Validators.required],
      testo: [this.data?.testo, Validators.required],
      campo: [this.data?.campo, Validators.required],
      ordinale: [this.data?.ordinale],
    });
  }

  campi = [
    'pagamento_del_premio',
    'esistenza_di_vincoli',
    'coassicurazioni_indirette',
    'sinistri_precedenti',
    'ubicazione_descrizione_rischio',
    'mezzi_chiusura',
    'causa_descrizione_sinistro',
    'riassunto_danni',
    'riserve_indennizzo',
    'impressioni_perito_condizioni_rischio',
    'note',
    'localita_e_data',
    'Descrizione Somma Assicurata',
  ]

}

